/**
 * CORE-1685 — одна эмодзи комплекта: картинка по слагу (старые слаги — через
 * сопоставление по смыслу), запасной символ для слага, которого у нас нет.
 * Общий для чипов реакций, палитры выбора и эмодзи в тексте.
 */
import React from 'react';
import { Image, Text, type ImageStyle, type StyleProp, type TextStyle } from 'react-native';
import { reactionOf } from '../../constants/brandReactions';
import { REACTION_EMOJI } from '../../services/chat/reactions';

interface Props {
  type: string;
  /** Сторона картинки в px. */
  size?: number;
  style?: StyleProp<ImageStyle>;
  /** Стиль запасного символа, когда картинки нет. */
  textStyle?: StyleProp<TextStyle>;
  /** Инлайн в тексте: картинка чуть опускается на базовую линию. */
  inline?: boolean;
}

export const ReactionGlyph: React.FC<Props> = ({ type, size = 20, style, textStyle, inline }) => {
  const reaction = reactionOf(type);
  if (!reaction) {
    const fallback = REACTION_EMOJI[type] ?? '❤️';
    return <Text style={[{ fontSize: size * 0.8 }, textStyle]}>{fallback}</Text>;
  }
  return (
    <Image
      source={reaction.image}
      accessibilityLabel={reaction.hint}
      style={[
        { width: size, height: size },
        inline ? { transform: [{ translateY: size * 0.2 }] } : null,
        style,
      ]}
      resizeMode="contain"
    />
  );
};
